<template>
    <router-view/>
</template>

<script>
export default {
    name: 'App'
}
</script>

<style>
#app {
}

body {
    background: url('~@/assets/img/main_bg.jpg') no-repeat top;
}    

</style>



// WEBPACK FOOTER //
// src/App.vue